import { defineStore } from "pinia";
import Product from "../../models/Product";

type CreateMutable<T> = { -readonly [P in keyof T]: CreateMutable<T[P]> };

export const useProductStore = defineStore("productStore", {
  state: () => ({
    products: new Array<Product>(),
  }),
  actions: {
    async SET_PRODUCTS(obj: Product[]) {
      this.products = [...obj];
    },
  },
  persist: true,
});
